//import tags
import { Link, useParams } from "react-router-dom";

//import locales
import { useTranslation } from "react-i18next";
import "../../i18n";

export default function Breadcrumb({title, url, subtitle}) {

    //imort locales
    const { t } = useTranslation();
    const { locale } = useParams();

    return (
        <div className="bg-gray-100 p-5">
            <div className="container mx-auto">
                <div className="flex items-center">
                    <Link to={`/${locale}`}>
                        <div className="text-[11px] md:text-[12px] lg:text-sm font-md me-3 upper">{t('home')}</div>
                    </Link>
                    <div>></div>
                    <Link to={url}>
                        <div className="text-[11px] md:text-[12px] lg:text-sm font-md ms-3 upper">{title}</div>
                    </Link>
                    {
                        subtitle ?
                            <>
                                <div className="ms-3">></div>
                                <div className="text-[11px] md:text-[12px] lg:text-sm font-md ms-3 upper">{subtitle}</div>
                            </>
                        :
                        ''
                    }
                    
                </div>
            </div>
        </div>
    );
}